<script>
    import Vue from 'vue';
    import Gravatar from 'vue-gravatar';

    Vue.component('v-gravatar', Gravatar);

    export default {

        props: {
            application: {
                type: Object,
                required: true
            }
        },

        computed: {
            iconImg() {
                return 'https://emalify-chat-dot-chatleo-111.appspot.com/faviconemali.png'
            },

            participant() {
                return {};
            }
        }
    }
</script>

<template>
    <div
        class="sc-header"
        :style="{
            background: application.color !== ''
            ? application.color
            : 'linear-gradient(45deg,#12259e,#3a52ea)'
        }"
    >

        <div class="sc-header__logo_section">

            <img
                class="sc-header--img"
                :src="application.url"
                v-if="application.url !== ''"
            />

            <img
                v-if="application.url === ''"
                class="sc-header--img"
                :src="iconImg"
            />

        </div>

        <div class="sc-header__title_area">

            <div class="sc-header--title">
                <span>{{ application.name }}</span>
            </div>

            <div class="sc-header--title-description">
                  <span>
                      <p>Here is the support team</p>
                  </span>
            </div>

        </div>

        <div class="sc-header__close_area">
            <div class="sc-header--close-button">
                <img src="" alt=""/>
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
    .sc-header {
        min-height: 75px;
        border-top-left-radius: 3px;
        border-top-right-radius: 3px;
        box-shadow: 0 1px 4px rgba(0,0,0,.2);
        position: relative;
        box-sizing: border-box;
        display: flex;
        padding: 10px;

        &__logo_section {
            width: 10%;
        }

        &__title_area {
            width: 80%;
            line-height: 15px;
        }

        &__close_area {
            width: 10%;
        }
    }

    .participants-avatar-list {
        display: flex;
        padding-left: 15px;
    }

    .participants {
        margin-right: 15px;
    }

    .sc-header--img {
        align-self: center;
        padding: 5px;
        width: 40px;
        height: 40px;
    }

    .sc-header--title {
        align-self: center;
        padding: 5px 10px;
        flex: 1;
        user-select: none;
        font-size: 14px;
        font-weight: bold;
        margin-left: 5px;
        color: #ffffff;
    }

    .sc-header--title-description {
        font-size: 12px;
        padding-left: 15px;
        color: rgba(255, 255, 255, 0.7);
    }

    .sc-header--title.enabled {
        cursor: pointer;
        border-radius: 5px;
    }

    .sc-header--title.enabled:hover {
        box-shadow: 0 2px 5px rgba(0.2, 0.2, 0.5, .1);
    }

    .sc-header--close-button {
        align-self: center;
        box-sizing: border-box;
        cursor: pointer;
        border-radius: 5px;
    }

    .sc-header--close-button:hover {
        box-shadow: 0px 2px 5px rgba(0.2, 0.2, 0.5, .1);
    }

    .sc-header--close-button img {
        width: 100%;
        height: 100%;
        padding: 13px;
        box-sizing: border-box;
    }

    @media (max-width: 450px) {
        .sc-header {
            border-radius: 0;
        }
    }
</style>
